var _defs, _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconSlg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-6717b730-ce9d-4489-ac64-3a752de0e05a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".uuid-a0b614d9-c2e1-49d0-89d0-64568bbaa11e{fill:#fff;fill-rule:evenodd;}.uuid-2fa9d3db-efdb-43b9-a417-342c1ea0e005{fill:#02467f;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "uuid-2fa9d3db-efdb-43b9-a417-342c1ea0e005",
    x: -0.5,
    y: -0.5,
    width: 513,
    height: 513
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-f26e5f5a-0014-467b-8e56-98a675cb3a1b"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-58d48d63-890c-4899-97ca-02b4bbf41043"
  }, /*#__PURE__*/React.createElement("g", {
    id: "uuid-6fd5a4e0-95c4-4fff-9314-21b7bc7c4682"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-b2b7dde2-f333-4e12-a15b-25c66cd4e430",
    className: "uuid-a0b614d9-c2e1-49d0-89d0-64568bbaa11e",
    d: "m192.83,85.37h98.77v106.81h-18.95v-87.93h-60.94v303.35h88.66v-174.44h-38.22v106.03h-18.97v-124.78h76v212.22h-126.35V85.52"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSlg);
export default __webpack_public_path__ + "static/media/icon_slg.21eace59de69c9b32c7144faa73d54e6.svg";
export { ForwardRef as ReactComponent };